<!----------------------------   Program description   ----------------------------
- Vue Name ID   : goodsOrderDlvyInfoPopup
- Vue Name  : 배송정보 변경 팝업
- Author      :
- Create Date : 2021.05.12
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
  <div class="layer-content">
    <table class="tb-row instt-tbl">
      <colgroup>
        <col style="width: 17%">
        <col style="width: 28%">
        <col style="width: 20%">
        <col style="width: 35%">
      </colgroup>
      <tbody>
      <tr>
        <th class="__left">수령인 이름</th>
        <td>
          <input type="text"
                 ref="rcverNm"
                 v-model="rcverNm">
        </td>
        <th class="__left">수령인 연락처</th>
        <td style="line-height: 25px">
          <select style="width: 60px;"
                  v-model="cttpc1">
            <option v-for="(cttpc, index) in defCttpc1"
                    :key="'cttpc_'+index"
                    :value="cttpc.cd">{{cttpc.name}}</option>
          </select>
          - <input type="text" style="width: 60px"
                   ref="cttpc2"
                   maxlength="4"
                   v-model="cttpc2">
          - <input type="text" style="width: 60px"
                   ref="cttpc3"
                   maxlength="4"
                   v-model="cttpc3">
        </td>
      </tr>
      <tr>
        <th class="__left">배송 주소</th>
        <td colspan="3">
          <div>
            <input type="text"
                   class="pdr5"
                   tabindex="3"
                   maxlength="6"
                   style="width: 70px !important;padding-right: 5px;"
                   ref="zip"
                   readonly
                   v-model="zip"/>
            <button class="middle _bt-ypurple"
                    style="width:82px;height: 36px;line-height: 30px;padding: 0px 5px;width: 70px;"
                    @click="openPostcodePopup">
              <span>검색</span>
            </button>
          </div>
          <div class="mgt5">
            <input type="text"
                   tabindex="4"
                   maxlength="50"
                   style="width: 90% !important;"
                   ref="adres1"
                   readonly
                   v-model="bassAdres"/>
          </div>
          <div class="mgt5">
            <input type="text"
                   tabindex="5"
                   maxlength="50"
                   style="width: 90% !important;"
                   ref="adres2"
                   v-model="detailAdres"
                   placeholder="※ 상세주소 입력이 필요 없을 경우 공란"/>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="btn-wrap t-line center mgt20">
      <button class="big _bt-white"
              @click="closePopup">
        <span>취소</span>
      </button>
      <button class="big _bt-navy"
              @click="modifyDlvyInfo()">
        <span>변경하기</span>
      </button>
    </div>
  </div>
</template>

<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
   * 2.1. Import
   *======================================================================================*/
export default {
  /*======================================================================================*
   * 2.2. 뷰 컴포넌트 명칭
   *======================================================================================*/
  name: 'goodsOrderDlvyInfoPopup',
  props: ['param', 'index'],
  /*======================================================================================*
   * 2.3. 지역 변수
   *======================================================================================*/
  data: function () {
    return {
      orderNo: '',
      dlvyNo: '',
      rcverNm: '',
      cttpc1: '',
      cttpc2: '',
      cttpc3: '',
      zip: '',
      bassAdres: '',
      detailAdres: '',
      defCttpc1: [
        {cd:'02', name: '02'},
        {cd:'031', name: '031'},
        {cd:'032', name: '032'},
        {cd:'033', name: '033'},
        {cd:'041', name: '041'},
        {cd:'042', name: '042'},
        {cd:'043', name: '043'},
        {cd:'044', name: '044'},
        {cd:'051', name: '051'},
        {cd:'052', name: '052'},
        {cd:'053', name: '053'},
        {cd:'054', name: '054'},
        {cd:'055', name: '055'},
        {cd:'061', name: '061'},
        {cd:'062', name: '062'},
        {cd:'063', name: '063'},
        {cd:'064', name: '064'},
        {cd:'010', name: '010'},
        {cd:'011', name: '011'},
        {cd:'016', name: '016'},
        {cd:'017', name: '017'},
        {cd:'018', name: '018'},
        {cd:'019', name: '019'},
      ]
    }
  },
  computed: {
    mberInfo : function(){
      return this.$store.getters.getMberInfo;
    },
  },
  /*======================================================================================*
   * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
   *======================================================================================*/
  methods: {
    init: function () {
      this.orderNo = this.param.orderNo;
      this.dlvyNo = this.param.dlvyNo;
      this.rcverNm = this.param.rcverNm;
      this.zip = this.param.zip;
      this.bassAdres = this.param.bassAdres;
      this.detailAdres = this.param.detailAdres;

      const cttpcList = this.param.cttpc.split('-');
      this.cttpc1 = cttpcList[0];
      this.cttpc2 = cttpcList[1];
      this.cttpc3 = cttpcList[2];
    },
    openPostcodePopup : function(){
      const _this = this;

      new window.daum.Postcode({
        oncomplete: function(data) {
          _this.zip = data.zonecode;
          _this.bassAdres = data.address;

          if(Number(_this.param.dlvyAmount) > 0){
            _this.searchDlvyAmountInfo();
          }
        }
      }).open();
    },
    searchDlvyAmountInfo: function(){
      this.axios.post('/i5gam/goods/searchDlvyAmountInfo.act', {
        zip: this.zip
      }).then(function(response){
        const dlvyAmountInfo = response.data.dlvyAmountInfo;
        let amount = 3000;
        if(dlvyAmountInfo!= null) amount += Number(dlvyAmountInfo.aditDlvyamount);

        if(this.param.dlvyAmount != amount){
          this.zip = this.param.zip;
          this.bassAdres = this.param.bassAdres;
          this.$toasted.show('배송비가 다른 경우는 고객센터 또는 1대1문의로 요청해주세요.');
          return false;
        }
      }.bind(this)).catch(function(e){
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    modifyDlvyInfo: function(){
      this.axios.post('/i5gam/goods/modifyDlvyInfo.act',{
        orderNo : this.orderNo,
        dlvyNo: this.dlvyNo,
        zip: this.zip,
        bassAdres: this.bassAdres,
        detailAdres: this.detailAdres,
        rcverNm: this.rcverNm,
        cttpc: this.cttpc1 + '-' + this.cttpc2 + '-' + this.cttpc3,
        mberNo: this.mberInfo.mberNo
      }).then(function(response){
        const code = response.data.procInfo.code;
        if(code == '000'){
          this.$toasted.show(this.$onbiLib.msg.suc.chng, {duration:1000, type:'success'});
          this.param.callBackFunc();
          this.closePopup();
        }
      }.bind(this)).catch(function(e){
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    closePopup: function(){
      this.$store.commit('closePopup', this.index);
    }
  },
  /*======================================================================================*
   * 2.4. Vue Life Cycle
   *======================================================================================*/
  mounted: function () {
    this.init();
  }
}
</script>

<!-------------------------------------------------------------------------------------
- 3. 뷰 스타일 block
--------------------------------------------------------------------------------------->
<style scoped>
</style>